// Generated by CoffeeScript 1.12.7
(function() {
  var compactFlattenIfNeeded, doFlattenInternal, isPlainArray, needsFlatteningOrCompacting;

  isPlainArray = require('./Types').isPlainArray;

  doFlattenInternal = function(array, output) {
    var el, i, len;
    for (i = 0, len = array.length; i < len; i++) {
      el = array[i];
      if (isPlainArray(el)) {
        doFlattenInternal(el, output);
      } else if (el != null) {
        output.push(el);
      }
    }
    return output;
  };

  needsFlatteningOrCompacting = function(array) {
    var el, i, len;
    for (i = 0, len = array.length; i < len; i++) {
      el = array[i];
      if ((el == null) || isPlainArray(el)) {
        return true;
      }
    }
    return false;
  };

  compactFlattenIfNeeded = function(array) {
    if (needsFlatteningOrCompacting(array)) {
      return doFlattenInternal(array, []);
    } else {
      return array;
    }
  };

  module.exports = {
    compactFlatten: function(array) {
      return compactFlattenIfNeeded(array);
    }
  };

}).call(this);
